// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"194b296e","444":"3c5379ac","635":"31a5c098"}[chunkId] + ".chunk.css";
};